<template>
	<div>
		<slot>Set content as inline template.</slot>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				title: null
			}
		},
		mounted() {
			this.$root.$on('add-title', (title) => {
				this.title = title;
			});
		}
	}

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Subcollection.vue